import React, { useState } from 'react';
import { string, shape, bool, object } from 'prop-types';

import Section from '~/views/common/Section';
import DataTable from '~/views/common/DataTable';
import BoolIcon from '~/views/common/BoolIcon';


const Login = ({
    primary_email: {
        email,
        sso_created,
        validated,
        created,
        modified,
        sso_data,
    },
}) => {
    // State for expanding/collapsing SSO data
    const [isExpanded, setIsExpanded] = useState(false);

    const buttonStyle = {
        padding: '8px 16px',
        fontSize: '14px',
        border: 'none',
        borderRadius: '4px',
        backgroundColor: isExpanded ? '#007BFF' : '#6C757D',
        color: 'white',
        cursor: 'pointer',
        outline: 'none',
        transition: 'background-color 0.3s ease',
    };

        // Style for button hover effect
    const buttonHoverStyle = {
        backgroundColor: isExpanded ? '#0056b3' : '#5a6268',
    };

    const scrollableContainerStyle = {
        maxHeight: '1200px', // Set a maximum height for the container
        overflowY: 'auto', // Enable vertical scrolling
        backgroundColor: '#f8f9fa', // Optional: add a background color
        padding: '10px', // Optional: add padding inside the container
        borderRadius: '4px', // Optional: add rounded corners
        border: '1px solid #ddd', // Optional: add a border
    };

    const renderSsoData = () => {
        if (sso_data === null) {
            return <p>SSO data not found for this user.</p>;
        }
        return (
            <div>
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={buttonStyle}
                    onMouseOver={e => e.target.style.backgroundColor = buttonHoverStyle.backgroundColor}
                    onMouseOut={e => e.target.style.backgroundColor = buttonStyle.backgroundColor}
                >
                    { isExpanded ? 'Collapse' : 'Expand' }
                </button>
                { isExpanded && (
                    <div style={scrollableContainerStyle}>
                        <pre>{ JSON.stringify(sso_data, null, 2) }</pre>
                    </div>
                ) }
            </div>
        );
    };

    return (
        <Section name="Login">
            <DataTable.Body>
                <DataTable.Row header="Email">{ email }</DataTable.Row>

                <DataTable.Row header="SSO Data">{ renderSsoData() }</DataTable.Row>

                <DataTable.Row header="Verified">
                    <BoolIcon value={validated} />
                </DataTable.Row>

                <DataTable.Row header="SSO">
                    <BoolIcon value={sso_created} />
                </DataTable.Row>

                <DataTable.Row header="Created">{ created }</DataTable.Row>

                <DataTable.Row header="Modified">{ modified }</DataTable.Row>
            </DataTable.Body>
        </Section>
    );
};

Login.propTypes = {
    primary_email: shape({
        email: string.isRequired,
        sso_created: bool.isRequired,
        validated: bool.isRequired,
        created: string.isRequired,
        modified: string.isRequired,
        sso_data: object,
    }).isRequired,
};

export default Login;
